<div class="container">
  <div class="offset-1 col-10">

    <div class=" content">
      <div class=" row">
        <div class=" col-12">
          <div class=" card card-chart">
            <div class=" card-header">
              <div class=" row">
                <div class=" col-sm-12 text-left">
                  <h5 class=" card-category">My Portfolio</h5>
                  <h2 class=" card-title"><span *ngIf="currentCluster"><i class="fab fa-elementor fa-lg"></i>&nbsp;&nbsp;&nbsp; Active Portfolio: {{ currentCluster.name }}</span><span *ngIf="!currentCluster"><i class="fab fa-elementor fa-lg"></i>&nbsp;&nbsp;&nbsp; Current Portfolio</span></h2>
                </div>

              </div>
            </div>
            <div class=" card-body">
              <div class="text-center">
                <h4 class="text-danger" *ngIf="clusterList && clusterList.length==0">Create a Portfolio in "Create Portfolio"</h4>
              </div>

              <div class="row" *ngIf="clusterList && clusterList.length">
                <div class="offset-4 col-4">
                  <mat-form-field class="w-100">
                    <mat-label style="color: grey">Select a portfolio in your cloud</mat-label>
                    <mat-select [disabled]="clusterLoading" style="color: white" [value]="currentCluster">
                      <mat-option [value]="undefined" (click)="onSelectCluster(undefined)">No cluster selected</mat-option>
                      <mat-option *ngFor="let cluster of clusterList" [value]="cluster" (click)="onSelectCluster(cluster)">{{ cluster.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="!selectedCluster || !currentCluster || selectedCluster.id!=currentCluster.id" class="col-3 mt-3">
                  <app-line-button (click)="onChangeCluster()">Apply</app-line-button>
                </div>
                <div *ngIf="selectedCluster" class="col-12" style="font-size: small">
                  <div class="row">
                    <div class="col-12" style="line-height: 30px">
                      <span style="color: rgb(118, 168, 255)">
                        {{ selectedCluster.name }}
                      </span>
                    </div>
                    <div class="col-6" style="line-height: 30px">
                      <div class="w-100" style="border-top:1px dotted grey"></div>
                      <span style="color: grey">
                        Benchmark
                      </span>
                      <span class="float-right">
                        {{ selectedCluster.benchmark_name }}
                      </span>
                    </div>
                    <div class="col-6" style="line-height: 30px">
                      <div class="w-100" style="border-top:1px dotted grey"></div>
                      <span style="color: grey">
                        Ticker
                      </span>
                      <span class="float-right">
                        {{ selectedCluster.ticker }}
                      </span>
                    </div>
                    <div class="col-6" style="line-height: 30px">
                      <span style="color: grey">
                        Investment zone
                      </span>
                      <span *ngIf="selectedCluster.investment_zone" class="float-right">
                        {{ selectedCluster.investment_zone.name }}
                      </span>
                    </div>
                    <div class="col-6" style="line-height: 30px">
                      <span style="color: grey">
                        Components
                      </span>
                      <span class="float-right">
                        {{ selectedCluster.nb_components }}
                      </span>
                    </div>
                    <div class="col-6" style="line-height: 30px">
                      <span style="color: grey">
                        Currency
                      </span>
                      <span *ngIf="selectedCluster.currency" class="float-right">
                        {{ selectedCluster.currency.name }}
                      </span>
                    </div>
                    <div class="col-6" style="line-height: 30px">
                      <span style="color: grey">
                        Creation date
                      </span>
                      <span class="float-right">
                        {{ selectedCluster.creation_date | date:'d MMM y' }}
                      </span>
                    </div>
                    <div class="col-6" style="line-height: 30px">
                      <span style="color: grey">
                        Market positions
                      </span>
                      <span *ngIf="selectedCluster.market_positions" class="float-right">
                        {{ selectedCluster.market_positions.name }}
                      </span>
                      <div class="w-100" style="border-bottom:1px dotted grey"></div>
                    </div>
                    <div class="col-6" style="line-height: 30px">
                      <span style="color: grey">
                        Period
                      </span>
                      <span class="float-right">
                        {{ selectedCluster.inception_date | date:'d MMM y' }}
                        —
                        {{ selectedCluster.last_date | date:'d MMM y' }}
                      </span>
                      <div class="w-100" style="border-bottom:1px dotted grey"></div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- State of the simulation -->
              <span *ngIf="selectedCluster" style="color: rgb(118, 168, 255)">
                <br>
                Status
              </span>
              <table *ngIf="selectedCluster" mdbTable small="true" class="mt-1">
                <thead>
                <tr>
                  <th scope="col" style="color: grey">Original portfolio</th>
                  <th scope="col" style="color: grey">Strategy Target</th>
                  <th scope="col" style="color: grey">Investable portfolio</th>
                  <th scope="col" style="color: grey">Protected portfolio</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td><mat-checkbox class="example-margin" [disabled]="true" [checked]="selectedCluster.has_original"></mat-checkbox></td>
                  <td><mat-checkbox class="example-margin" [disabled]="true" [checked]="selectedCluster.has_strategy"></mat-checkbox></td>
                  <td><mat-checkbox class="example-margin" [disabled]="true" [checked]="selectedCluster.has_investable"></mat-checkbox></td>
                  <td><mat-checkbox class="example-margin" [disabled]="true" [checked]="selectedCluster.has_protected"></mat-checkbox></td>
                </tr>
                </tbody>
              </table>
              <!-- State of the simulation -->

            </div>
            <div *ngIf="selectedCluster" class=" card-footer">
              <div class="row">
                <div class="col-6 text-center">
                  <app-button color="danger" (click)="onDeleteCluster()">Delete the Cluster</app-button>
                </div>
                <div class="col-6 text-center">
                  <app-button (click)="onViewReport()">View Report</app-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br>
  </div>
</div>
